import { useToolsStore } from '~/store/tools/tools'

export default defineNuxtRouteMiddleware(async () => {
  const toolsStore = useToolsStore()

  if (!toolsStore.menuItems.length) {
    await toolsStore.getMenuItems()
  }
})
